'use client'; // Error components must be Client Components
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { Product } from '@/models/product';
import {
  getChildCategories,
  getProductsByCategoryId,
} from '@/features/ProductListing/services/getProducts';
import ErrorPageLinks from '@/features/Error/ErrorPageLinks';
import { storage } from '@/config';
import { pushGA4Event } from '@/utils/helper';

export default function Error({
  error,
}: {
  error?: Error & { digest?: string };
}) {
  const [shopCategories, setShopCategories] = useState<Product[]>([]);
  const [mostLovedRecipes, setMostLovedRecipes] = useState<Product[]>([]);
  const [mostViewedStories, setMostViewedStories] = useState<Product[]>([]);
  const [upcomingWorkshops, setUpcomingWorkshops] = useState<Product[]>([]);

  useEffect(() => {
    pushGA4Event('page_error', {
      error_code: String(error?.digest || error?.message || 'unknown_error'),
    });
  }, [error]);

  const getShopCategories = async () => {
    const shopCategoriesList = await getChildCategories({
      slug: '3',
      store_code: storage?.get('store_code') || undefined,
    });
    if (shopCategoriesList?.items) {
      setShopCategories(shopCategoriesList?.items);
    }
  };
  const getMostLovedRecipes = async () => {
    const mostLovedRecipesList = await getProductsByCategoryId({
      categoryId: process.env.MOST_LOVED_RECIPES_CATEGORY_ID,
    });
    if (mostLovedRecipesList?.items) {
      setMostLovedRecipes(mostLovedRecipesList?.items);
    }
  };
  const getMostViewedStories = async () => {
    const mostViewedStoriesList = await getProductsByCategoryId({
      categoryId: process.env.MOST_VIEWED_STORIES_CATEGORY_ID,
    });
    if (mostViewedStoriesList?.items) {
      setMostViewedStories(mostViewedStoriesList?.items);
    }
  };
  const getUpcomingWorkshops = async () => {
    const upcomingWorkshopsList = await getProductsByCategoryId({
      categoryId: process.env.UPCOMING_WORKSHOPS_CATEGORY_ID,
    });
    if (upcomingWorkshopsList?.items) {
      setUpcomingWorkshops(upcomingWorkshopsList?.items);
    }
  };

  useEffect(() => {
    getShopCategories();
    getMostLovedRecipes();
    getMostViewedStories();
    getUpcomingWorkshops();
  }, []);

  return (
    <div>
      <div className='relative mb-40 flex h-[502px] w-full flex-col items-center justify-center bg-neutral-700'>
        <Image src='/vectors/oops.svg' alt='Copy' width={300} height={30} />
        <div className='absolute bottom-0 m-8 flex max-w-211.5 translate-y-1/2 transform flex-col items-center justify-center gap-2 bg-white p-8 py-8 shadow-sm  md:px-16.5 md:py-12.5'>
          <div className='text-md text-center font-semibold md:text-[1.625rem] '>
            Sorry, It’s Not You. It’s Us
          </div>
          <div className='text-center'>
            <span className='text-sm font-medium'>
              Well, this is awkward. We are experiencing an internal server
              problem and we’re working to fix it. We’ll be up and running
              shortly.
            </span>
          </div>
        </div>
      </div>
      <ErrorPageLinks
        shopCategories={shopCategories}
        mostLovedRecipes={mostLovedRecipes}
        mostViewedStories={mostViewedStories}
        upcomingWorkshops={upcomingWorkshops}
      />
    </div>
  );
}
